import { TFunction } from 'i18next'
import { UnionVehicle } from 'model'
import { IGroup } from 'office-ui-fabric-react'

export function generateVehicleGroups(
  vehiclesByProving: {
    id: string
    title: string
    models: {
      id: string
      vehicles: UnionVehicle[]
    }[]
  }[],
  t: TFunction
) {
  const items: UnionVehicle[] = []
  const groups: IGroup[] = []

  let totalVehiclesAdded = 0
  vehiclesByProving.forEach((prov) => {
    const children: IGroup[] = []
    let vehiclesAddedForProving = 0

    prov.models.forEach((model) => {
      let vehiclesAddedForModel = 0

      model.vehicles.forEach((veh) => {
        items.push(veh as UnionVehicle)
        vehiclesAddedForProving++
        vehiclesAddedForModel++
        totalVehiclesAdded++
      })

      children.push({
        key: model.id,
        name: model.id ? model.id : t('[Modell unbekannt]'),
        startIndex: totalVehiclesAdded - vehiclesAddedForModel,
        count: vehiclesAddedForModel,
        level: 1,
      })
    })

    groups.push({
      key: prov.id,
      name: `${prov.title} (${prov.id})`,
      startIndex: totalVehiclesAdded - vehiclesAddedForProving,
      count: vehiclesAddedForProving,
      children,
      level: 0,
    })
  })

  return { items, groups }
}
